"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _customPropTypes = require("../helpers/customPropTypes");

var _Keyboard = require("../__beta__/Keyboard/Keyboard");

var _Keyboard2 = _interopRequireDefault(_Keyboard);

var _Key = require("../__beta__/Keyboard/Key");

var _Key2 = _interopRequireDefault(_Key);

var _Icon = require("../Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _PrevNextArrowButton = require("./PrevNextArrowButton");

var _PrevNextArrowButton2 = _interopRequireDefault(_PrevNextArrowButton);

require("./PrevNextArrows.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevNextArrows = function (_Component) {
  _inherits(PrevNextArrows, _Component);

  function PrevNextArrows() {
    _classCallCheck(this, PrevNextArrows);

    return _possibleConstructorReturn(this, (PrevNextArrows.__proto__ || Object.getPrototypeOf(PrevNextArrows)).apply(this, arguments));
  }

  _createClass(PrevNextArrows, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          ariaPrevArrow = _props.ariaPrevArrow,
          ariaNextArrow = _props.ariaNextArrow,
          isPrevDisabled = _props.isPrevDisabled,
          isNextDisabled = _props.isNextDisabled,
          keyTriggerPrev = _props.keyTriggerPrev,
          keyTriggerNext = _props.keyTriggerNext,
          onClickPrevArrow = _props.onClickPrevArrow,
          onClickNextArrow = _props.onClickNextArrow,
          tooltipAlign = _props.tooltipAlign,
          tooltipTextPrevArrow = _props.tooltipTextPrevArrow,
          tooltipTextNextArrow = _props.tooltipTextNextArrow,
          tooltipTextPrevArrowKey = _props.tooltipTextPrevArrowKey,
          tooltipTextNextArrowKey = _props.tooltipTextNextArrowKey,
          size = _props.size,
          type = _props.type,
          moreProps = _objectWithoutProperties(_props, ["ariaPrevArrow", "ariaNextArrow", "isPrevDisabled", "isNextDisabled", "keyTriggerPrev", "keyTriggerNext", "onClickPrevArrow", "onClickNextArrow", "tooltipAlign", "tooltipTextPrevArrow", "tooltipTextNextArrow", "tooltipTextPrevArrowKey", "tooltipTextNextArrowKey", "size", "type"]);

      return _react2.default.createElement(
        _Keyboard2.default,
        null,
        _react2.default.createElement(_Key2.default, { code: keyTriggerPrev, onKeyMatch: this.props.onClickPrevArrow }),
        _react2.default.createElement(_Key2.default, { code: keyTriggerNext, onKeyMatch: this.props.onClickNextArrow }),
        _react2.default.createElement(
          "div",
          { className: "prev-next-arrows__wrapper" },
          _react2.default.createElement(
            _PrevNextArrowButton2.default,
            _extends({
              ariaLabel: ariaPrevArrow,
              className: "prev-next-arrows__prev",
              isDisabled: isPrevDisabled,
              keyTrigger: keyTriggerPrev,
              onClick: onClickPrevArrow,
              size: size,
              tooltipAlign: tooltipAlign,
              tooltipText: tooltipTextPrevArrow,
              tooltipTextForKey: tooltipTextPrevArrowKey,
              type: type
            }, moreProps),
            _react2.default.createElement(_Icon2.default, { type: "arrow-up" })
          ),
          _react2.default.createElement(
            _PrevNextArrowButton2.default,
            _extends({
              ariaLabel: ariaNextArrow,
              className: "prev-next-arrows__next",
              isDisabled: isNextDisabled,
              onClick: onClickNextArrow,
              keyTrigger: keyTriggerNext,
              size: size,
              tooltipAlign: tooltipAlign,
              tooltipText: tooltipTextNextArrow,
              tooltipTextForKey: tooltipTextNextArrowKey,
              type: type
            }, moreProps),
            _react2.default.createElement(_Icon2.default, { type: "arrow-down" })
          )
        )
      );
    }
  }]);

  return PrevNextArrows;
}(_react.Component);

PrevNextArrows.propTypes = {
  ariaPrevArrow: _propTypes2.default.string,
  ariaNextArrow: _propTypes2.default.string,
  isPrevDisabled: _propTypes2.default.bool.isRequired,
  isNextDisabled: _propTypes2.default.bool.isRequired,

  /** Pressing this key will fire onClickPrevArrow/onClickNextArrow. If using this with something other than a letter (e.g. 'uparrow', 'escape'), wrap the component in an <L10n>. */
  keyTriggerPrev: _propTypes2.default.string,
  keyTriggerNext: _propTypes2.default.string,

  onClickPrevArrow: _propTypes2.default.func.isRequired,
  onClickNextArrow: _propTypes2.default.func.isRequired,
  size: _customPropTypes.shirtSize,
  tooltipAlign: _propTypes2.default.string,

  /** The text that appears in the tooltip on the next/prev arrow. */
  tooltipTextNextArrow: _propTypes2.default.string,
  tooltipTextPrevArrow: _propTypes2.default.string,

  /** The text that appears on the second line in the tooltip (indicating which key triggers it, if any). It will automatically be surrounded with square brackets. */
  tooltipTextNextArrowKey: _propTypes2.default.string,
  tooltipTextPrevArrowKey: _propTypes2.default.string,

  /** The type of ACL-UI button it should be. */
  type: _propTypes2.default.oneOf(["default", "primary", "secondary", "destructive", "flat", "minor", "link"])
};

PrevNextArrows.defaultProps = {
  ariaPrevArrow: "Previous",
  ariaNextArrow: "Next",
  keyTriggerPrev: "arrowup",
  keyTriggerNext: "arrowdown",
  size: "medium",
  tooltipAlign: "bottomLeft",
  tooltipTextNextArrow: "arrowup",
  tooltipTextPrevArrow: "arrowdown",
  type: "default"
};

exports.default = PrevNextArrows;